module.exports = __webpack_public_path__ + "img/14.d2df521c.jpg";